import React from 'react';
import BuildingsCheckList from './buildingsCheckList';
import PeriodCheckList from './periodCheckList';
import DateRangeSelect from './dateRangeSelect';
import MonthRangeSelect from './monthRangeSelect';
import DayPeriodSelect from './dayPeriodSelect';
import BuildingSelect from './buildingSelect';
import DaySelect from './daySelect';
import MonthSelect from './monthSelect';
import ScheduleSelector from './scheduleSelector';
import soapRequest from '../../helpers/soapRequest';
import xmlParserGetFilterExtraData from '../../helpers/xmlParserGetFilterExtraData';
import { BUILDINGS_CHECKLIST, DATE_RANGE_SELECT, DAY_PERIOD_SELECT, BUILDING_SELECT, DAY_SELECT, MONTH_RANGE_SELECT, MONTH_SELECT, PERIOD_CHECKLIST, SCHEDULE_SELECTOR } from '../../helpers/constants';

import Typography from '@mui/material/Typography';

class SpaceTimeSelector extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			spaceFilterData: [],
			fromDate: null,
			untilDate: null,
			scheduleData: [],
			selectedPeriod: null
		}
		this.handleChangeTimeSelect = this.handleChangeTimeSelect.bind(this);
		this.handleChangeSpaceSelect = this.handleChangeSpaceSelect.bind(this);
		this.handleChangePeriodChecklist = this.handleChangePeriodChecklist.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.subFilters !== this.props.subFilters) {
			this.setState({
				spaceFilterData: [],
				scheduleData: [],
				fromDate: null,
				untilDate: null,
				selectedPeriod: null
			});
		}
	}

	handleChangeTimeSelect(data){
		const { id } = this.props

		if(data === null){
			this.setState({
				spaceFilterData: [],
				scheduleData: [],
				fromDate: null,
				untilDate: null,
				selectedPeriod: null
			});
			return;
		}
		const token = sessionStorage.getItem('userToken');

		var extraDataXmlArray = [];
		extraDataXmlArray.push(
			'<message>',
				'<token>',
				token,
				'</token>',
				'<filterId>',
				id,
				'</filterId>',
				'<subFilterId>',
				data.filterId,
				'</subFilterId>',
				'<parameters>',
				  '<parameter>',
					'<id>',
					-1,
					'</id>',
					'<name>',
					data.fromDate,
					'</name>',
				  '</parameter>',
				  '<parameter>',
					'<id>',
					-1,
					'</id>',
					'<name>',
					data.untilDate,
					'</name>',
				  '</parameter>',
				'</parameters>',
			'</message>'
		);

		var extraDataXml = extraDataXmlArray.join("");
		const timeout = 10000;

		soapRequest('getFilterExtraData', timeout, extraDataXml).then((result) => {
			const [extraDataList] = xmlParserGetFilterExtraData(result);
			this.setState({
				fromDate: data.fromDate,
				untilDate: data.untilDate,
				selectedPeriod: null,
				spaceFilterData: extraDataList,
				scheduleData: [],
			});
		});
		
	}

	handleChangePeriodChecklist(data){
		const { id } = this.props

		if(data === null){
			this.setState({
				spaceFilterData: [],
				scheduleData: [],
				fromDate: null,
				untilDate: null,
				selectedPeriod: null
			});
			return;
		}
		const token = sessionStorage.getItem('userToken');

		var periodID = null; 
		var paramsArray = [];
		data.periods.map(period => {
			periodID = period.id;
			paramsArray.push(
				'<parameter>',
					'<id>',
					period.id,
					'</id>',
					'<name>',
					period.name,
					'</name>',
				'</parameter>'
			);
		});
		var paramsXml = paramsArray.join("");

		var extraDataXmlArray = [];
		extraDataXmlArray.push(
			'<message>',
				'<token>',
				token,
				'</token>',
				'<filterId>',
				id,
				'</filterId>',
				'<subFilterId>',
				data.filterId,
				'</subFilterId>',
				'<parameters>',
				paramsXml,
				'</parameters>',
			'</message>'
		);

		var extraDataXml = extraDataXmlArray.join("");
		const timeout = 10000;

		soapRequest('getFilterExtraData', timeout, extraDataXml).then((result) => {
			const [extraDataList] = xmlParserGetFilterExtraData(result);
			this.setState({
				fromDate: null,
				untilDate: null,
				selectedPeriod: periodID,
				spaceFilterData: extraDataList,
				scheduleData: [],
			});
		});
		
	}

	handleChangeSpaceSelect(data){
		const { id } = this.props
		const { fromDate, selectedPeriod }  = this.state;

		if(data === null){
			this.setState({
				scheduleData: []
			});
			return;
		}

		const token = sessionStorage.getItem('userToken');
		//time params
		var timeParam = [];
		if(selectedPeriod !== null){
			timeParam.push(
				'<parameter>',
					'<id>',
					selectedPeriod,
					'</id>',
				'</parameter>',
			);
		} else {
			timeParam.push(
				'<parameter>',
					'<name>',
					fromDate,
					'</name>',
				'</parameter>',
			);
		}
		var timeParamXml = timeParam.join("");

		var extraDataXmlArray = [];
		extraDataXmlArray.push(
			'<message>',
				'<token>',
				token,
				'</token>',
				'<filterId>',
				id,
				'</filterId>',
				'<subFilterId>',
				data.filterId,
				'</subFilterId>',
				'<parameters>',
				timeParamXml,
				'<parameter>',
					'<id>',
					data.building.id,
					'</id>',
					'<name>',
					data.building.name,
					'</name>',
				'</parameter>',
				'</parameters>',
			'</message>'
		);

		var extraDataXml = extraDataXmlArray.join("");
		const timeout = 10000;

		soapRequest('getFilterExtraData', timeout, extraDataXml).then((result) => {
			const [extraDataList] = xmlParserGetFilterExtraData(result);
			this.setState({
				scheduleData: extraDataList
			});
		});
	}

	render() {
		const{ subFilters } = this.props;
		const{ spaceFilterData, scheduleData} = this.state;
		var filtersArrayComponent = []

		//set time
		for (var i = 0; i < subFilters.length; i++) {
			switch (parseInt(subFilters[i].filterId)) {
			  case DATE_RANGE_SELECT:
				filtersArrayComponent.push(
				  <DateRangeSelect {...this.props}
					id={subFilters[i].filterId}
					name={subFilters[i].filterName}
					data={subFilters[i].filterData}
					required={subFilters[i].required}
					defines = {subFilters[i].defines}
					key={i}
					handleTimeSelect={this.handleChangeTimeSelect}
				  />);
				break;
			  case DAY_SELECT:
				filtersArrayComponent.push(
				  <DaySelect {...this.props}
					id={subFilters[i].filterId}
					name={subFilters[i].filterName}
					data={subFilters[i].filterData}
					required={subFilters[i].required}
					defines = {subFilters[i].defines}
					key={i}
					handleTimeSelect={this.handleChangeTimeSelect}
				  />);
				break;
			  case MONTH_RANGE_SELECT:
				filtersArrayComponent.push(
				  <MonthRangeSelect {...this.props}
					id={subFilters[i].filterId}
					name={subFilters[i].filterName}
					data={subFilters[i].filterData}
					required={subFilters[i].required}
					defines = {subFilters[i].defines}
					key={i}
					handleTimeSelect={this.handleChangeTimeSelect}
				  />);
				break;
			  case MONTH_SELECT:
				filtersArrayComponent.push(
				  <MonthSelect {...this.props}
					id={subFilters[i].filterId}
					name={subFilters[i].filterName}
					data={subFilters[i].filterData}
					required={subFilters[i].required}
					defines = {subFilters[i].defines}
					key={i}
					handleTimeSelect={this.handleChangeTimeSelect}
				  />);
				break;
			  case PERIOD_CHECKLIST:
				filtersArrayComponent.push(
				  <PeriodCheckList {...this.props}
					id={subFilters[i].filterId}
					name={subFilters[i].filterName}
					data={subFilters[i].filterData}
					required={subFilters[i].required}
					defines = {subFilters[i].defines}
					key={i}
					handleChangePeriodChecklist={this.handleChangePeriodChecklist}
				  />);
				break;
			  default:
				break;
			}
		}
		//set space
		for (var i = 0; i < subFilters.length; i++) {
			switch (parseInt(subFilters[i].filterId)) {
			  case BUILDINGS_CHECKLIST:
				filtersArrayComponent.push(
				  <BuildingsCheckList {...this.props}
					id={subFilters[i].filterId}
					name={subFilters[i].filterName}
					data={spaceFilterData}
					required={subFilters[i].required}
					defines = {subFilters[i].defines}
					key={i}
					handleChangeSpaceSelect={this.handleChangeSpaceSelect}
				  />);
				break;
			  case BUILDING_SELECT:
				filtersArrayComponent.push(
				  <BuildingSelect {...this.props}
					id={subFilters[i].filterId}
					name={subFilters[i].filterName}
					data={spaceFilterData}
					required={subFilters[i].required}
					defines = {subFilters[i].defines}
					key={i}
					handleChangeSpaceSelect={this.handleChangeSpaceSelect}
				  />);
				break;
			  default:
				break;
			}
		}
		//set horarios xd
		for (var i = 0; i < subFilters.length; i++) {
			switch (parseInt(subFilters[i].filterId)) {
				case DAY_PERIOD_SELECT:
					filtersArrayComponent.push(
						<DayPeriodSelect {...this.props}
						id={subFilters[i].filterId}
						name={subFilters[i].filterName}
						data={subFilters[i].filterData}
						required={subFilters[i].required}
						defines = {subFilters[i].defines}
						key={i}
						/>);
					break;
				case SCHEDULE_SELECTOR:
					filtersArrayComponent.push(
						<ScheduleSelector {...this.props}
						id={subFilters[i].filterId}
						name={subFilters[i].filterName}
						data={scheduleData}
						required={subFilters[i].required}
						defines = {subFilters[i].defines}
						key={i}
						/>);
					break;
			  default:
				break;
			}
		}

		return (
			<div>
				{filtersArrayComponent}
			</div>
		)
	}
}

export default SpaceTimeSelector;